import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllSaldoBancarioUseCase } from "../../../presentation/useCases/read/get_all_saldo_bancario_use_case";
import { SaldoBancarioCadastroFilter } from "../../models/saldo_bancario_cadastro_filter";
import { SaldoBancarioCadastroLista } from "../../models/saldo_bancario_cadastro_lista";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetAllSaldoBancarioUseCase
 */

export class GetAllSaldoBancarioUseCase extends BasePaginatedUseCase<SaldoBancarioCadastroLista> implements IGetAllSaldoBancarioUseCase {
  constructor(private readonly repository: IFinanceiroRepository) {
    super();

  }

  async getAllSaldoBancarioLista(
    filter: SaldoBancarioCadastroFilter,
    currentPage: number,
    rowsPerPage: number
  ): Promise<void> {
    const response = await this.repository.getAllSaldoBancarioLista(filter, currentPage, rowsPerPage);

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  };



}

